import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const ClearFilterIcon = (props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 20"
    sx={{
      height: '18px',
      width: '18px',
    }}
  >
    <path
      fill={props.sx?.color || COLORS.black50}
      d="M3.28 3.003a.28.28 0 0 0-.28.28v.839c0 .07.03.14.079.192L7.109 8.6h4.092l4.031-4.285c.01-.01.019-.024.026-.035.012-.017.028-.033.035-.052.008-.021.006-.048.01-.07.001-.013.008-.02.008-.035v-.84a.28.28 0 0 0-.28-.28H3.28Zm4.197 6.155v4.757c0 .098.055.185.14.236l2.798 1.678c.044.027.09.044.14.044.047 0 .097-.01.14-.035a.282.282 0 0 0 .14-.245V9.158H7.476Zm4.73 2.79a.331.331 0 0 0-.035.008.281.281 0 0 0-.14.48l2.037 2.038-2.037 2.037a.284.284 0 1 0 .402.403l2.038-2.038 2.037 2.038c.111.111.29.111.402 0a.284.284 0 0 0 0-.403l-2.037-2.037 2.037-2.037a.278.278 0 0 0 .06-.328.279.279 0 0 0-.296-.153.282.282 0 0 0-.166.079l-2.037 2.037-2.038-2.037a.28.28 0 0 0-.227-.088Z"
    />
  </SvgIcon>
);

ClearFilterIcon.propTypes = {
  sx: PropTypes.object,
};

export default ClearFilterIcon;
